"use client";

import * as React from "react";
import * as HoverCardPrimitive from "@radix-ui/react-hover-card";
import { cn } from "@/lib/utils";

export function HoverCard({
  children,
  delay = 100,
  ...props
}: HoverCardPrimitive.HoverCardProps & { delay?: number }) {
  const [open, setOpen] = React.useState(false);
  const timerRef = React.useRef<NodeJS.Timeout | null>(null);

  const handleOpenChange = (nextOpen: boolean) => {
    if (nextOpen) {
      timerRef.current = setTimeout(() => {
        setOpen(true);
      }, delay);
    } else {
      clearTimeout(timerRef.current!);
      setOpen(false);
    }
  };

  return (
    <HoverCardPrimitive.Root
      open={open}
      onOpenChange={handleOpenChange}
      {...props}
    >
      {children}
    </HoverCardPrimitive.Root>
  );
}

export function HoverCardTrigger({
  children,
  ...props
}: HoverCardPrimitive.HoverCardTriggerProps) {
  return (
    <HoverCardPrimitive.Trigger asChild {...props}>
      {children}
    </HoverCardPrimitive.Trigger>
  );
}

export function HoverCardContent({
  className,
  sideOffset = 4,
  align = "center",
  ...props
}: HoverCardPrimitive.HoverCardContentProps) {
  return (
    <HoverCardPrimitive.Portal>
      <HoverCardPrimitive.Content
        sideOffset={sideOffset}
        align={align}
        className={cn(
          "z-50 w-64 rounded-md border bg-white p-4 text-black shadow-md outline-none",
          "data-[state=open]:animate-in data-[state=closed]:animate-out",
          "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
          "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
          "data-[side=bottom]:slide-in-from-top-2",
          "data-[side=left]:slide-in-from-right-2",
          "data-[side=right]:slide-in-from-left-2",
          "data-[side=top]:slide-in-from-bottom-2",
          className
        )}
        {...props}
      />
    </HoverCardPrimitive.Portal>
  );
}
